const Fez = window.Fez;
if (!Fez) throw new Error('fez runtime not loaded: load fez (window.Fez) before component modules');

// --- ui-dialog ---
let __fez_component_0;
{
const FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])'
__fez_component_0 = class {
  MOUNT = true
  GLOBAL = 'Dialog'

  init() {
    this.state.open = false
    this.state.mode = 'component'
    this.state.title = ''
    this.state.text = ''
    this.state.size = 'md'
    this.state.seq = 0
    this.on(document, 'keydown', (event) => this.onKey(event))
  }

  open(tag, props = {}, { title = '', size = 'md' } = {}) {
    this.settle(undefined)
    const element = document.createElement(tag)
    for (const [key, value] of Object.entries(props)) {
      if (value !== undefined && value !== null) {
        element.setAttribute(key, typeof value === 'string' ? value : JSON.stringify(value))
      }
    }
    this.state.pending = element
    return this.show({ mode: 'component', title, size })
  }

  confirm({ title = 'Are you sure?', text = '', confirm = 'Confirm', danger = false } = {}) {
    this.settle(undefined)
    this.state.text = text
    this.state.confirmLabel = confirm
    this.state.danger = danger
    return this.show({ mode: 'confirm', title, size: 'sm' }).then(Boolean)
  }

  show({ mode, title, size }) {
    this.state.returnFocus = document.activeElement
    this.state.mode = mode
    this.state.title = title
    this.state.size = size
    this.state.seq++
    this.state.open = true
    document.documentElement.style.overflow = 'hidden'
    return new Promise((resolve) => (this.state.resolve = resolve))
  }

  afterRender() {
    if (!this.state.open) return
    if (this.state.pending && this.state.body) {
      this.state.body.replaceChildren(this.state.pending)
      this.state.pending = null
    }
    this.setTimeout(() => {
      const panel = this.state.panel
      if (!panel || panel.contains(document.activeElement)) return
      const target = panel.querySelector('[autofocus], input, select, textarea') || panel.querySelector('.dialog-actions > :last-child') || panel
      target.focus()
    }, 40)
  }

  isOpen() {
    return Boolean(this.state.open)
  }

  /** Retitles the open dialog, e.g. when its content steps to another item. */
  setTitle(title) {
    this.state.title = title
  }

  /** Closes the dialog; `value` resolves the promise returned by open(). */
  close(value) {
    if (!this.state.open) return
    this.state.open = false
    document.documentElement.style.overflow = ''
    this.settle(value)
    this.state.returnFocus?.focus?.()
  }

  cancel() {
    this.close(undefined)
  }

  settle(value) {
    const resolve = this.state.resolve
    this.state.resolve = null
    resolve?.(value)
  }

  onKey(event) {
    if (!this.state.open) return
    if (event.key === 'Escape') {
      event.preventDefault()
      this.cancel()
      return
    }
    if (event.key !== 'Tab' || !this.state.panel) return
    const items = [...this.state.panel.querySelectorAll(FOCUSABLE)].filter((el) => el.offsetParent !== null)
    if (!items.length) return
    const first = items[0]
    const last = items[items.length - 1]
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault()
      last.focus()
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault()
      first.focus()
    }
  }

  CSS = `:fez {
display:contents;.backdrop{position:fixed;inset:0;z-index:var(--z-dialog);display:none;align-items:flex-start;justify-content:center;padding:12vh var(--space-4) var(--space-4);background:var(--color-overlay);overflow-y:auto;&.open{display:flex}&:has(.panel.xl){padding-top:4vh}}.panel{width:100%;max-width:520px;border:1px solid var(--color-border);border-radius:var(--radius-xl);background:var(--color-bg-raised);box-shadow:var(--shadow-lg);outline:0;&.sm{max-width:420px}&.lg{max-width:720px}&.xl{max-width:1040px}}header{display:flex;align-items:center;justify-content:space-between;gap:var(--space-3);padding:var(--space-5) var(--space-5) 0 var(--space-6);h2{font-size:var(--text-lg)}}.body{padding:var(--space-4) var(--space-6) var(--space-6)}.text{color:var(--color-text-muted)}
}`

  CSS_GLOBAL = `.dialog-actions{display:flex;justify-content:flex-end;gap:var(--space-2);margin-top:var(--space-6)}`

  HTML = `<div class="backdrop" class:open={state.open} onclick!="fez.cancel()">
{#if state.open}
<div class="panel {state.size}" role="dialog" aria-modal="true" aria-label={state.title} tabindex="-1" fez:this="panel" fez:in="pop, duration=180">
<header>
<h2>{state.title}</h2>
<ui-button variant="ghost" size="sm" icon="x" title="Close" onclick="Dialog.cancel()"></ui-button>
</header>
{#if state.mode === 'confirm'}
<div class="body">
<p class="text">{state.text}</p>
<div class="dialog-actions">
<ui-button label="Cancel" onclick="Dialog.cancel()"></ui-button>
<ui-button variant={state.danger ? 'danger' : 'primary'} label={state.confirmLabel} onclick="Dialog.close(true)"></ui-button>
</div>
</div>
{:else}
<div class="body" fez:keep="dialog-body-{state.seq}" fez:this="body"></div>
{/if}
</div>
{/if}
</div>`
};
}

Fez('ui-dialog', __fez_component_0);

export default __fez_component_0;
